<template>
    <div class="app-container py-4 px-0 px-sm-4">
        <v-row class="d-flex justify-center mx-0">
            <v-col cols="12" md="4" class="hidden-sm-and-down pr-4">
                <profile-menu @logout="logout" :active-link="5"></profile-menu>
            </v-col>
            <v-fade-transition v-if="showForm" leave-absolute>
                <v-col sm="8">
                    <h1 class="justify-center pa-0">{{ metaData.header }}</h1>
                    <v-stepper v-model="steps" class="background-transparent">
                        <div class="d-flex justify-center">
                            <v-stepper-header class="stepper-header">
                                <v-stepper-step
                                        :complete="steps > 1"
                                        step="1"
                                        color="main--yellow "
                                >
                                    <div>
                                        {{$t('productData')}}
                                    </div>
                                </v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step
                                        :complete="steps > 2"
                                        step="2"
                                        color="main--yellow "
                                >
                                    <div>
                                        {{$t('characteristics')}}
                                    </div>
                                </v-stepper-step>
                            </v-stepper-header>
                        </div>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <main-info-step
                                        ref="mainInfoStep"
                                        @validated="onMainInfoValidated"
                                        @category-change="categoryChange"
                                ></main-info-step>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <characteristics-step
                                        :productAttributes="productCharacteristics"
                                        ref="characteristicsStep"
                                        @back="goBack"
                                        @validated="onCharacteristicsValidated"
                                ></characteristics-step>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-col>
            </v-fade-transition>
            <v-fade-transition v-if="!showForm" leave-absolute>
                <v-col sm="6" class="pb-4">
                    <v-card outlined class="pb-12 border-transparent">
                        <v-card-title :class="['white--text justify-center', result.css]">
                            {{ result.header }}
                        </v-card-title>
                        <v-list>
                            <v-list-item-group>
                                    <v-btn
                                            v-if="result.product"
                                            @click="showForm = true"
                                            large
                                            text
                                            class="text--main-yellow"
                                            width="100%"
                                    >
                                        {{ $t('addMore') }}
                                    </v-btn>
                                    <v-btn
                                            v-if="result.product"
                                            link
                                            large
                                            text
                                            class="text--main-yellow"
                                            :to="productLink"
                                            width="100%"
                                    >
                                        {{ $t('productPage') }}
                                    </v-btn>
                                    <v-btn
                                            v-if="result.product"
                                            link
                                            large
                                            text
                                            class="text--main-yellow"
                                            :to="`/profile/products/update/${result.product.id}`"
                                            width="100%"
                                    >
                                        {{ $t('change') }}
                                    </v-btn>
                                    <v-btn
                                            link
                                            large
                                            text
                                            class="text--main-yellow"
                                            to="/profile/products"
                                            width="100%"
                                    >
                                        {{ $t('myProducts') }}
                                    </v-btn>
                                    <v-btn
                                            link
                                            large
                                            text
                                            class="text--main-yellow"
                                            to="/contact-us"
                                            width="100%"
                                    >
                                        {{ $t('contactUs') }}
                                    </v-btn>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-col>
            </v-fade-transition>
        </v-row>
        <load-overlay :overlay="overlay"></load-overlay>
        <v-snackbar
                color="main--black"
                dark
                v-model="snackOpen"
                top
        >
            {{ $t('yourProductSaved') }}
            <div class="d-flex">
                <v-btn v-if="result.product" text class="text--main-yellow" link :to="productLink" >{{ $t('productPage') }}</v-btn>
                <v-btn text icon @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
    import './product-add.scss'

    import AddProductService from '../../../../app-front/services/api/AddProductService';
    import InfoService from '../../../../app-front/services/api/InfoService';
    import AppSnack from '../../../../general/mixins/AppSnack';
    import CharacteristicsStep from './CharacteristicsStep';
    import MultipleImageInput from '../../../../general/image/multiple-image-input';
    import MainInfoStep from './MainInfoStep';
    import ProductAttribute from './ProductAttribute';
    import ProfileMenu from '../../../../app-front/components/profile/menu';
    import RegionsMultiple from '../../../../general/geo/regions-multiple/RegionsMultiple';
    import RouteAccess from '../../../../app-front/mixins/RouteAccess';
    import SnackGeneral from '../../../../app-front/components/snacks/SnackGeneral';
    import LoadOverlay from "../../../../app-front/components/overlays/LoadOverlay";

    export default {
        name: "ProductAdd",
        props: [],
        mixins: [AppSnack, RouteAccess],
        components:{
            MultipleImageInput,
            ProductAttribute,
            RegionsMultiple,
            MainInfoStep,
            CharacteristicsStep,
            ProfileMenu,
            SnackGeneral,
            LoadOverlay
        },
        data() {
            return {
                attributesValues:{},
                metaUrl: '/products/add',
                steps: 1,
                dialog: false,
                formData: {},
                productCharacteristics: [],
                showForm: true,
                result: {
                    css: '',
                    header: '',
                    id: null,
                    product: null
                },
                snackData: {
                    isOpen: false,
                    color: '',
                    text: ''
                },
                overlay: false
            }
        },

        methods: {
            assignData(data) {
                this.formData = Object.assign(this.formData, data);
            },
            categoryChange(categoryID) {
                if(!categoryID) {
                    this.productCharacteristics = [];

                    return false;
                }

                InfoService.setLocale(this.$store.state.language.appLanguage);
                InfoService.getAttributesCategory(categoryID)
                    .then(res => {
                        this.productCharacteristics = res.data;
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            createProduct() {
                this.overlay = true;
                AddProductService.create(this.getFormData())
                    .then(res => {
                        this.$emit('success',res.data);
                        this.steps = 1;
                        this.result.css = 'success';
                        this.result.header = this.$t('addProductSuccess');
                        this.result.id = res.data.success.product.id;
                        this.result.product = res.data.success.product;
                        setTimeout(() => {
                            this.overlay = false;
                            this.showForm = false;
                            this.openSnack();
                        },2000)
                    })
                    .catch(err => {
                        this.result.css = 'error';
                        this.result.header = this.$t('addProductError');
                        this.result.id = null;
                        this.result.product = null
                        this.showForm = false;
                        this.overlay = false;
                        this.$emit('error');
                        this.openSnack();
                        console.log(err);
                    });
            },
            goBack() {
              if (this.steps > 1) {
                  this.steps -= 1;
              }
            },
            onMainInfoValidated(data) {
                this.steps = 2;
                this.assignData(data);
            },
            onCharacteristicsValidated(data) {
                this.assignData(data);
                //this.openSnack();
                this.createProduct();
            },
            getFormData() {
                const formData = new FormData();
                Object.keys(this.formData).forEach(key => {
                    if(key === 'productImages') {
                        this.formData[key].forEach(item => {
                            let name = 'images[]';
                            formData.append(name, item);
                        });
                    } else {
                        formData.append(key, JSON.stringify(this.formData[key]))
                    }
                });

                return formData;
            },
            snackHandle(text, color, isOpen) {
                this.snackData.color = color;
                this.snackData.text = text;
                this.snackData.isOpen = isOpen;
            },
        },
        computed: {
            productLink() {
                return {
                    name: 'product',
                    params: {
                        parentCategory: this.result.product.parentCategoryName.toString(),
                        category: this.result.product.categoryName.toString(),
                        sysNameWithId: `${this.result.product.productName}-${this.result.product.id}`
                    }
                }
            },
        },
        watch: {
            steps() {
                window.scrollTo(0, 0);
            }
        }
    }
</script>
